
import React from 'react';
import HNWICaseStudyCard from './HNWICaseStudyCard';
import AnimateInView from '@/components/ui/animate-in-view';

// Sample case studies data
export const caseStudies = [
  {
    id: "estate-security",
    title: "Private Waterfront Estate Security",
    image: "/images/Private-Waterfront-Estate-Security1.png",
    challenge: "A high-profile client needed comprehensive security for their 50-acre waterfront estate without compromising the property's aesthetic appeal or announcing security measures to visitors.",
    solution: "We implemented our fiber-optic in-ground detection system around the perimeter with zero visual impact, integrated with existing landscaping and custom monitoring systems.",
    outcome: "Complete peace of mind with zero aesthetic compromise. Our client gained 24/7 intelligent monitoring that differentiates between natural wildlife movement and actual security threats.",
    link: "/solutions/fibre"
  },
  {
    id: "farm-protection",
    title: "Agricultural Property Protection",
    image: "/images/Agricultural-Property-Protection1.png",
    challenge: "A luxury farm property experienced repeated unauthorized access issues that threatened valuable equipment and prize-winning livestock.",
    solution: "We deployed our on-fence detection technology, calibrated to distinguish between wind disturbance and genuine intrusion attempts, covering over 3 kilometers of perimeter.",
    outcome: "Eliminated all unauthorized access incidents within the first month of operation, with zero false alarms and complete preservation of the property's rural character.",
    link: "/solutions/fence"
  },
  {
    id: "vineyard-security",
    title: "Luxury Vineyard Surveillance",
    image: "/images/Luxury-Vineyard-Surveillance1.png",
    challenge: "A prestigious vineyard needed to protect valuable crops and equipment while maintaining an inviting atmosphere for tourism and high-end clientele.",
    solution: "Custom hybrid security solution combining in-ground sensors in key areas with AI-powered analysis to identify genuine threats while remaining invisible to guests.",
    outcome: "Comprehensive protection achieved without affecting the property's premium visitor experience or revealing the extensive security measures in place.",
    link: "/solutions/bespoke"
  }
];

/**
 * @component CaseStudies
 * @description Component showcasing premium case studies
 * @returns {JSX.Element} Section with case study cards
 */
const CaseStudies: React.FC = () => {
  return (
    <section className="section bg-forti-fi-background" aria-labelledby="case-studies-heading">
      <div className="container mx-auto">
        <AnimateInView animation="fade-in">
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <div className="gold-divider mx-auto"></div>
            </div>
            <h2 id="case-studies-heading" className="text-3xl md:text-4xl tracking-tight text-forti-fi mb-6">
              Success Stories
            </h2>
            <p className="text-center max-w-2xl mx-auto mb-12 text-forti-fi-charcoal">
              Discover how our discreet security solutions have protected high-value properties without compromising aesthetics or lifestyle
            </p>
          </div>
        </AnimateInView>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {caseStudies.map((caseStudy, index) => (
            <HNWICaseStudyCard 
              key={caseStudy.id}
              caseStudy={caseStudy}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
